import { connect } from 'react-redux';
import { compose } from 'redux'
import { withFirebase } from '../Firebase';
import { withAxios } from '../api';
import { withAuthorization } from '../Session';

import { setViewState } from '../../actions';

import MapV2 from './MapV2';

const mapState = ({ firebaseReducer, viewStateReducer }) => ({
  user: firebaseReducer.user,
  viewState: viewStateReducer,
})

export default compose(
  withAxios,
  connect(
    mapState,
    { setViewState }
  ))(MapV2)

